/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationcolumnsender2Inputs */

const en_moderationcolumnsender2 = /** @type {(inputs: Moderationcolumnsender2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender`)
};

const de_moderationcolumnsender2 = /** @type {(inputs: Moderationcolumnsender2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absender`)
};

/**
* | output |
* | --- |
* | "Sender" |
*
* @param {Moderationcolumnsender2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationcolumnsender2 = /** @type {((inputs?: Moderationcolumnsender2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationcolumnsender2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationcolumnsender2(inputs)
	return de_moderationcolumnsender2(inputs)
});
export { moderationcolumnsender2 as "moderationColumnSender" }